import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.7 Case 7</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="self_assessment_107"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number 107. This is a negative
                case. Beginning at the level of the cerebellum and scrolling
                superiorly, you can immediately see two areas of intense uptake,
                located here and here. These findings are anterior to the
                temporal lobes. And in order to demonstrate this, simply
                localize either region and utilize the sagittal or the coronal
                views to ensure that, in fact, this activity is located anterior
                to the temporal lobes and is not intense uptake within the
                temporal gray matter. Returning to the transverse images and
                scrolling superiorly, we enter into the temporal and occipital
                lobes, seen here. Distinct white matter tracts are easily
                identifiable on the right-hand side as well as on the left-hand
                side, as seen here. There is no loss of gray-white contrast.
                Although mildly intense uptake is seen in the occipital lobe in
                this region, it is important to follow this activity superiorly
                to ensure that it is, in fact, part of the white matter tract,
                as seen on the right-hand side. As we continue moving upward,
                distinct white matter tracts continue to be seen throughout the
                temporal and occipital lobes. Entering into the frontal
                cortices, we can identify white matter tracts on the left-hand
                side, as well as on the right-hand side. There is no loss of
                gray-white contrast in the frontal cortices bilaterally. In
                addition, white matter tracts are easily delineated as they move
                from the anterior to the posterior aspect of the brain on the
                right-hand side, as well as on the left-hand side. Entering into
                the parietal region, there is normal gray-white contrast
                throughout, with the distinct gray-white differentiation, and
                white matter tracts are easily identifiable at this level as
                well. As we enter into the medial parietal region, once again
                there is no loss of gray-white contrast in the area of the
                precuneus. And in fact, gray-white contrast is preserved. White
                matter tracts are also seen extending from the anterior aspect
                to the posterior aspect on the left-hand side and the right-hand
                side of the upper parietal lobes. As we review the remainder of
                the scan, it is clear that there is no loss of gray-white
                contrast. Therefore, this case is negative. If you called this
                case positive, please review this scan once again in the MIM
                Viewer.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-6"
          nextLesson="/module-3/module-3-0-8"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1648705101&entry_id=1_bik41z5x&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_bik41z5x"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
